import axios from '../../config/axiosConfig';
import {
    GET_UOMS,
    UOM_REQUEST,
    UOM_REQUEST_FAILURE,
    CREATE_UOM, DELETE_UOM, UPDATE_UOM,
} from '../types';

export const getUoms = () => {
    return async (dispatch, getState) => {
        const { auth } = getState();
        try {
            return axios.get('/uom/getAll',{ params: { userId: auth?.superUser?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_UOMS, payload: response.data });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: UOM_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: UOM_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createUom = (state) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: UOM_REQUEST });
            const { auth } = getState();
            return axios.post("/uom/add", state, { params: { userId: auth?.superUser?.id } }).then((response) => {
                if (response.data) {
                    dispatch({ type: CREATE_UOM, payload: response.data });
                    // dispatch(getStates());
                } else {
                    dispatch({
                        type: UOM_REQUEST_FAILURE,
                        error: "UOM create failed.",
                    });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: UOM_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: UOM_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateUom = (id, uomData) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: UOM_REQUEST });
            const { auth } = getState();
            return axios.put('/uom/update', { id, uomData }, { params: { userId: auth.superUser?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_UOM, payload: { id, data: response.data } });
                } else {
                    dispatch({ type: UOM_REQUEST_FAILURE, error: 'UOM update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: UOM_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: UOM_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteUom = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: UOM_REQUEST });
            return axios.delete(`/uom/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_UOM, id: id });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: UOM_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: UOM_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};